import React from 'react';
import Slider from "react-slick";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import certyfikat1 from '../../../assets/certificates/certyfikat-1.png';
import certyfikat2 from '../../../assets/certificates/certyfikat-2.png';
import certyfikat3 from '../../../assets/certificates/certyfikat-3.png';
import certyfikat4 from '../../../assets/certificates/certyfikat-4.png';
import certyfikat5 from '../../../assets/certificates/certyfikat-5.png';
import certyfikat6 from '../../../assets/certificates/certyfikat-6.png';
import certyfikat7 from '../../../assets/certificates/certyfikat-7.png';
import certyfikat8 from '../../../assets/certificates/certyfikat-8.png';
import certyfikat9 from '../../../assets/certificates/certyfikat-9.png';
import certyfikat10 from '../../../assets/certificates/certyfikat-10.png';
import certyfikat11 from '../../../assets/certificates/certyfikat-11.png';
import certyfikat12 from '../../../assets/certificates/certyfikat-12.png';
import certyfikat13 from '../../../assets/certificates/certyfikat-13.png';
import certyfikat14 from '../../../assets/certificates/certyfikat-14.png';
import certyfikat15 from '../../../assets/certificates/certyfikat-15.png';
import certyfikat16 from '../../../assets/certificates/certyfikat-16.png';
import certyfikat17 from '../../../assets/certificates/certyfikat-17.png';
import certyfikat18 from '../../../assets/certificates/certyfikat-18.png';
import certyfikat19 from '../../../assets/certificates/certyfikat-19.png';
import certyfikat20 from '../../../assets/certificates/certyfikat-20.png';
import certyfikat21 from '../../../assets/certificates/certyfikat-21.png';
import certyfikat22 from '../../../assets/certificates/certyfikat-22.png';
import certyfikat23 from '../../../assets/certificates/certyfikat-23.png';
import certyfikat24 from '../../../assets/certificates/certyfikat-24.png';
import certyfikat25 from '../../../assets/certificates/certyfikat-25.png';
import certyfikat26 from '../../../assets/certificates/certyfikat-26.png';
import certyfikat27 from '../../../assets/certificates/certyfikat-27.png';


const QualificationsSlider = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        className: 'qualifications-slider__slider-container',
        dotsClass: 'qualifications-slider__dots-container'
    };

    const options = {
        settings: {
            transitionSpeed: 900,
            hideControlsAfter: false,
            overlayColor: '#000'
        },
        buttons: {
            backgroundColor: "#fff",
            iconColor: "#4a4a4a",
            showAutoplayButton: false,
            showDownloadButton: false,
            showThumbnailsButton: false
        },
        caption: {
            showCaption: false,
        }
    };

    return (
        <section className="qualifications-slider">
            <div className="container">
                <div className="qualifications-slider__text-image">
                    <div className="qualifications-slider__text-box">
                        <p className="qualifications-slider__paragraph">
                            Aby skutecznie pomagać moim pacjentom, od wielu lat poszerzam swoją wiedzę
                            i&nbsp;umiejętności, uczestnicząc w&nbsp;szkoleniach, kursach oraz konferencjach naukowych
                            związanych z dziedziną fizjoterapii. 
                        </p>
                    </div>
                    <div className="qualifications-slider__carousel">
                        <h2 className="qualifications-slider__carousel-title">Certyfikaty</h2>
                            <Slider {...settings}>
                                <div className="qualifications-slider__carousel-slide">
                                    <SimpleReactLightbox>
                                        <SRLWrapper options={options}>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat1} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat1} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat2} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat2} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat3} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat3} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">                                     
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat4} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat4} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat5} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat5} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat6} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat6} alt="costam" />
                                                </a>
                                            </div>
                                        </SRLWrapper>
                                    </SimpleReactLightbox>
                                </div>
                                <div className="qualifications-slider__carousel-slide">
                                    <SimpleReactLightbox>
                                        <SRLWrapper options={options}>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat7} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat7} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat8} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat8} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat9} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat9} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat10} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat10} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat11} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat11} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat12} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat12} alt="costam" />
                                                </a>
                                            </div>
                                        </SRLWrapper>
                                    </SimpleReactLightbox>
                                </div>
                                <div className="qualifications-slider__carousel-slide">
                                    <SimpleReactLightbox>
                                        <SRLWrapper options={options}>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat13} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat13} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat14} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat14} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat15} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat15} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat16} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat16} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat17} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat17} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat18} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat18} alt="costam" />
                                                </a>
                                            </div>
                                        </SRLWrapper>
                                    </SimpleReactLightbox>
                                </div>
                                <div className="qualifications-slider__carousel-slide">
                                    <SimpleReactLightbox>
                                        <SRLWrapper options={options}>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat19} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat19} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat20} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat20} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat21} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat21} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat22} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat22} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat23} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat23} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat24} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat24} alt="costam" />
                                                </a>
                                            </div>
                                        </SRLWrapper>
                                    </SimpleReactLightbox>
                                </div>
                                <div className="qualifications-slider__carousel-slide">
                                    <SimpleReactLightbox>
                                        <SRLWrapper options={options}>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat25} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat25} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat26} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat26} alt="costam" />
                                                </a>
                                            </div>
                                            <div className="qualifications-slider__element">
                                                <a className="qualifications-slider__carousel-anchor" href={certyfikat27} data-attribute="SRL">
                                                    <img className="qualifications-slider__carousel-image" src={certyfikat27} alt="costam" />
                                                </a>
                                            </div>
                                        </SRLWrapper>
                                    </SimpleReactLightbox>
                                </div>
                            </Slider>
                    </div>                    
                </div>
            </div>
        </section>
    );
}

export default QualificationsSlider;